(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8414],{

/***/ 81631:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404-not-found",
      function () {
        return __webpack_require__(95740);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ErrorsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58718);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43795);






var ErrorsPage = function(param) {
    var title = param.title, pageImage = param.pageImage, description = param.description;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: intl.formatMessage({
                        id: title
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                component: "div",
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    pt: {
                        tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(96),
                        mobile: "30px"
                    },
                    height: "100"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        img: pageImage,
                        title: intl.formatMessage({
                            id: title
                        }),
                        objectFit: "contain",
                        sx: {
                            width: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(288),
                                mobile: "205px"
                            },
                            height: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(165),
                                mobile: "120px"
                            },
                            mb: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(24),
                                mobile: "24px"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        component: "p",
                        sx: {
                            fontSize: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(20),
                                mobile: "16px"
                            },
                            textAlign: "center",
                            maxWidth: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(461),
                                mobile: "461px"
                            },
                            lineHeight: "150%",
                            color: theme.palette.grey[50],
                            fontWeight: "bold"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: description
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 95740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_errors_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50920);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36822);



var NotfoundIcon = "/icons/shared/not-found-no-data.svg";
var SomeThingWentWrong = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_errors_page__WEBPACK_IMPORTED_MODULE_1__/* .ErrorsPage */ .j, {
            title: "page_not_found.title",
            description: "page_not_found.description",
            pageImage: NotfoundIcon
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SomeThingWentWrong);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(81631); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);